/**
 * React entry point for Wko.Web
 * Exposes page-level mount functions on window.WkoReact for use from Razor views.
 * Each converted page gets its own mount function.
 *
 * KO-React bridge:
 *   WkoReact.registerReactComponent('MyChart', MyChartComponent);
 *   WkoReact.bridgeKoComponent('mychart', 'MyChart');
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { registerKoComponent, registerReactComponent } from './utils/koReactBridge';
import { AlertSettingsPage } from './components/alertSettings/AlertSettingsPage';
import { AccountDetails } from './components/settings/AccountDetails';
import { IndustryStatsPage } from './components/industryStats/IndustryStatsPage';
import { RegionalStatsPage } from './components/industryStats/RegionalStatsPage';
import { ActivityStatsPage } from './components/industryStats/ActivityStatsPage';
import { LevelsInformation } from './components/industryStats/LevelsInformation';
import { FleetSummary } from './components/quarterlyInsights/FleetSummary';
import { VesselsAttentionTable } from './components/quarterlyInsights/VesselsAttentionTable';
import { VesselsStaleSync } from './components/quarterlyInsights/VesselsStaleSync';
import { WorkloadOutliersTable } from './components/quarterlyInsights/WorkloadOutliersTable';
import { QuarterlyInsightsPage } from './components/quarterlyInsights/QuarterlyInsightsPage';
import { NcReviewPage } from './components/ncReview/NcReviewPage';
import { NcReviewVesselListPage } from './components/ncReview/NcReviewVesselListPage';
import { VesselDetailsPage } from './components/vesselDetails/VesselDetailsPage';
export { registerReactComponent };
export { registerKoComponent as bridgeKoComponent };
registerReactComponent('AccountDetails', AccountDetails);
registerReactComponent('FleetSummary', FleetSummary);
registerReactComponent('VesselsAttentionTable', VesselsAttentionTable);
registerReactComponent('VesselsStaleSync', VesselsStaleSync);
registerReactComponent('QuarterlyInsightsWorkloadOutliersTable', WorkloadOutliersTable);
registerReactComponent('LevelsInformation', LevelsInformation);
export function mountAlertSettings(elementId) {
    const container = document.getElementById(elementId);
    if (!container) {
        console.error(`[WkoReact] Element '${elementId}' not found`);
        return;
    }
    createRoot(container).render(React.createElement(AlertSettingsPage));
}
export function mountIndustryStats(elementId) {
    const container = document.getElementById(elementId);
    if (!container) {
        console.error(`[WkoReact] Element '${elementId}' not found`);
        return;
    }
    createRoot(container).render(React.createElement(IndustryStatsPage));
}
export function mountRegionalStats(elementId) {
    const container = document.getElementById(elementId);
    if (!container) {
        console.error(`[WkoReact] Element '${elementId}' not found`);
        return;
    }
    createRoot(container).render(React.createElement(RegionalStatsPage));
}
export function mountActivityStats(elementId) {
    const container = document.getElementById(elementId);
    if (!container) {
        console.error(`[WkoReact] Element '${elementId}' not found`);
        return;
    }
    createRoot(container).render(React.createElement(ActivityStatsPage));
}
export function mountQuarterlyInsights(elementId) {
    const container = document.getElementById(elementId);
    if (!container) {
        console.error(`[WkoReact] Element '${elementId}' not found`);
        return;
    }
    createRoot(container).render(React.createElement(QuarterlyInsightsPage));
}
export function mountNcReview(elementId) {
    const container = document.getElementById(elementId);
    if (!container) {
        console.error(`[WkoReact] Element '${elementId}' not found`);
        return;
    }
    createRoot(container).render(React.createElement(NcReviewPage, { reportBaseUrl: '/Reports/GetNcTimesheetReport' }));
}
export function mountNcReviewVesselList(elementId) {
    const container = document.getElementById(elementId);
    if (!container) {
        console.error(`[WkoReact] Element '${elementId}' not found`);
        return;
    }
    createRoot(container).render(React.createElement(NcReviewVesselListPage));
}
export function mountVesselDetails(elementId, imo) {
    const container = document.getElementById(elementId);
    if (!container) {
        console.error(`[WkoReact] Element '${elementId}' not found`);
        return;
    }
    createRoot(container).render(React.createElement(VesselDetailsPage, { imo }));
}
